module.exports = __webpack_public_path__ + "img/resolve1.5494b699.png";